import React from 'react';
import SampleChart from "./SampleChart";
import AddplusIcon from "./AddplusIcon";

const AddSection = (props) => {

  return (<>
      <div className={"row"}>
        {props.data.map((v, index) => <div className={"col-xs-12 col-sm-6 col-md-4"}
                                           key={index}>
          <SampleChart
            entity={props.entity}
            onEdit={() => props.onEdit(v.id , v.title)}
            onDelete={() => props.onDelete(v.id , v.title)}
            title={v.title} color={v.color}/>
        </div>)}
        <AddplusIcon onClick={props.add}/>
      </div>
    </>);
};

export default AddSection;
